import { render, staticRenderFns } from "./add_case.vue?vue&type=template&id=15355fc6&scoped=true"
import script from "./add_case.vue?vue&type=script&lang=js"
export * from "./add_case.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/case_management_add_case.css?vue&type=style&index=0&id=15355fc6&prod&scoped=true&lang=css&external"
import style1 from "./add_case.vue?vue&type=style&index=1&id=15355fc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15355fc6",
  null
  
)

export default component.exports